import axios from 'axios'
import useSWR from 'swr'
import { useUser } from './useUser'

const fetcher = (url: string) => axios.get(url).then((res) => res.data)

export const useConsentDecision = (consentType: ConsentType) => {
  const { isLoggedIn } = useUser()
  const { data } = useSWR(
    isLoggedIn && `/api/consent_decisions/me/${consentType}`,
    fetcher
  )

  return { consentDecision: data }
}

type ConsentType =
  | 'all_marketing'
  | 'terms_and_conditions'
  | 'privacy_policy'
  | 'cookies_advertising'
  | 'cookies_analytical'
  | 'cookies_functional'
